<script>
    import {eventBus} from '../../main'
    export default {
        methods:{
            $fullUrl(uri){
                // return this.$store.state.api.serverUrl + uri
            },
            $notifyAppError(message) {
                eventBus.$emit('app-error', {
                        isError: true,
                        message: message
                    }
                )
            },
        }
    }
</script>